import { Component } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import { of, throwError } from "rxjs";
import { MessageBoxComponent } from './message-box-modal.component';


const ImpersonateRejectText: string = "You do not have access to perform this action while in Impersonate.";
const DemoRejectText: string = "You do not have access to perform this action while in Demo Mode.";

@Component({
    selector: 'my-authentication-handler-modal',
    templateUrl: 'message-box-modal.component.html'
})
export class AuthenticationHandlerComponent extends MessageBoxComponent {

    constructor(){
        super();
        this.buttonText = "OK";
        this.hideCancelButton = true;
    }

    /**
     * Handle HTTP error when trying to take action an an alert.
     * @param response the caught Response
     * @throws response - always, never returns.
     */
    actionErrorResponseHandler(response: HttpErrorResponse) {
        // Somebody else already handled it?
        if (response.status === 409) {

            // Pass to app-level error dialog
            let error = new Error(JSON.stringify(response.error));
            try { error.message = response.error; } catch (notJSON) {}

            error.name = "Conflict";
            throwError(error);
        }
        else if(response.status === 401){

            this.modalHeader = ''; //Needed so in IE the title does not show up as null

            if(JSON.stringify(response.error).includes("Demo")){
                this.displayText = DemoRejectText;
            }
            else if(JSON.stringify(response.error).includes("Impersonate")){
                this.displayText = ImpersonateRejectText;
            }

            this.show();

            /*
             We are assuming that the user is in impersonate mode here.
             We don't want to kick them out by throwing the Unauthorized to the browser.
             Instead, we return a blank observable that will remove nothing from the table.
             */
            return of(null);
        }

        // Rethrow to app-level error dialog
        throwError(response);
    }
}